module.exports = __webpack_public_path__ + "static/media/grey.efbdd643.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/grey.PNG
// module id = 513
// module chunks = 0